import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { StarRating } from "@/components/StarRating";
import { Avatar } from "@/components/Avatar";

export const RatingText = ({ rating, starSize = 12, textClass = "text-xs text-slate-500 font-medium", testid }) => {
  const { t, lang } = useLanguage();
  const count = rating?.count || 0;
  if (count === 0) {
    return <span data-testid={testid} className="text-xs text-slate-400">{t("rating.new")}</span>;
  }
  const locale = { pt: "pt-PT", en: "en-US", fr: "fr-FR", es: "es-ES", de: "de-DE", it: "it-IT" }[lang] || "pt-PT";
  const avg = rating.avg.toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5">
      <StarRating value={rating.avg} size={starSize} />
      <span className={textClass}>{avg} <span className="text-slate-400 font-normal">({count} {t("trip.reviews")})</span></span>
    </span>
  );
};

export const UserIdentity = ({ user, avatarSize = "w-9 h-9", avatarText = "text-sm", nameClass = "text-sm font-semibold text-slate-800", testid, avatarTestid, linkable = true }) => {
  const navigate = useNavigate();
  const open = (e) => {
    if (!linkable) return;
    e.preventDefault();
    e.stopPropagation();
    if (user?.id) navigate(`/utilizador/${user.id}`);
  };
  return (
    <span role={linkable ? "link" : undefined} tabIndex={linkable ? 0 : undefined} data-testid={testid} onClick={open} onKeyDown={(e) => e.key === "Enter" && open(e)} className={`inline-flex items-center gap-2.5 group ${linkable ? "cursor-pointer" : ""}`}>
      <Avatar user={user} size={avatarSize} text={avatarText} testid={avatarTestid} />
      <span>
        <span className={`block ${linkable ? "group-hover:underline" : ""} ${nameClass}`}>{user?.name}</span>
        <RatingText rating={user?.rating} testid={testid ? `${testid}-rating` : undefined} />
      </span>
    </span>
  );
};
